@use "Styles/mixins";

:host {
    position: fixed;
    z-index: mixins.get-z(toast-component, container);
    display: block;
    // The host opts into the Popover API (`popover="manual"`) so toasts render
    // in the top layer above any open `<dialog>`. The UA stylesheet for popovers
    // applies `inset: 0; margin: auto; width: fit-content; height: fit-content`
    // — we override below so our bottom-center / bottom-right anchoring wins.
    inset: auto;
    width: auto;
    height: auto;
    margin: 0;
    padding: 0;
    border: none;
    background: transparent;
    overflow: visible;

    // Mobile: bottom center
    bottom: calc(16px + env(safe-area-inset-bottom, 0px));
    left: 50%;
    transform: translateX(-50%);

    @include mixins.desktop-and-up {
        // Desktop: bottom right
        bottom: 36px;
        left: auto;
        right: 24px;
        transform: none;
    }
}

.vm-toast-container {
    &__list {
        display: flex;
        flex-direction: column;
        gap: 8px;
    }
}
